import React from "react"
import { useState, useEffect } from "react"
import {
  Box,
  Typography,
  Button,
  Card,
  CardContent,
  Grid,
  FormControl,
  IconButton,
  Stack,
  Autocomplete,
  TextField,
  Select,
  MenuItem,
  Dialog,
  DialogContent,
  DialogTitle,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Pagination,
  InputLabel,
} from "@mui/material"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import "react-datepicker/dist/react-datepicker.css"
import {
  ApiGetAllocations,
  ApiGetVisitTimes,
  ApiGetVenueList,
  ApiPutUpdateAllocation,
  ApiPostCreateAllocations,
  ApiPutCancelJob,
  ApiGetClientEntityByClientGroupId,
} from "../../../apiService/Core/Apicall.tsx"
import { toast } from "react-toastify"
import moment from "moment"
import useDebounce from "./UseDebounce.tsx"
import { visitDaysOptions, monthsData, yearData } from "../../../global/constants/globalContants.ts"
import { useDispatch, useSelector } from "react-redux"
import type { RootState } from "../../../global/config/store.ts"
import { setSelectedClientGroup } from "../../../global/config/Reducer/clientSlice.ts"
import { setDate } from "../../../global/config/Reducer/dateSlice.ts"

interface JobAllocation {
  id: number
  venue: string
  address: string
  postcode: string
  tradeHours: string
  time: string
}

export default function CreateAllocations() {
  const selectedClientName = useSelector((state: RootState) => state.client.selectedClient)
  const selectedDateRedux = useSelector((state: RootState) => state.date.selectedDate)
  const dispatch = useDispatch()
  const [currentDate, setCurrentDate] = useState(new Date(selectedDateRedux))
  const [allocations, setAllocations] = useState<JobAllocation[]>([])
  const [startDate, setStartDate] = useState<any>("")
  const [endDate, setEndDate] = useState<any>("")
  const [bulkCreateValue, setBulkCreateValue] = useState("Bulk Create")
  const [monthly, setMonthly] = useState([])
  const [year, setYear] = useState(null)
  const [allocationCreateCount, setallocationCreateCount] = useState(1)
  const [isNeedallocationCount, setIsNeedallocationCount] = useState<boolean>(false)
  const [every, setEvery] = useState("")
  const [visitTimes, setVisitTimes] = useState<any>([])
  const [venus, setVenus] = useState([])
  const [visitDays, setVisitDays] = useState<any>("")
  const [visitTimesValue, setVisitTimesValue] = useState<any>("")
  const [allocation, setAllocation] = useState<any>()
  const [allocationStatus, setAllocationStatus] = useState<any>()
  const [selectedValues, setSelectedValues] = useState("")
  const [venueName, setVenueName] = useState([])
  const [venueNameValue, setVenueNameValue] = useState<any>(null)
  const [clientEntityList, setClientEntityList] = useState<any>([])
  const [clientEntityId, setClientEntityId] = useState<string | null>(null)
  const [addComment, setAddComment] = useState("")
  const debouncedClientEntityId = useDebounce(clientEntityId, 500)
  const debouncedVenue = useDebounce(venueNameValue, 700)
  const [minAge, setMinAge] = useState()
  const [maxAge, setMaxAge] = useState()
  const [gender, setGender] = useState()

  // Updated pagination state
  const [currentPage, setCurrentPage] = useState(1)
  const [totalCount, setTotalCount] = useState(0)
  const itemsPerPage = 10

  const Clientlist = useSelector((state: RootState) => state.client.clientList)
  const [selectedClient, setSelectedClient] = useState<any>(selectedClientName)
  const [ClientId, setClientId] = useState(null)

  useEffect(() => {
    if (Clientlist.length > 2) {
      // setSelectedClient(Clientlist[2])
      setClientId(Clientlist[2].clientGroupName)
    }
  }, [Clientlist])


  useEffect(() => {
    setSelectedClient(selectedClientName)
  }, [selectedClientName])

  // Updated useEffect to handle client changes
  useEffect(() => {
    if (selectedClient) {
      const jobMonth = currentDate.getMonth() + 1
      const jobYear = currentDate.getFullYear()
      ApiCallGetAllocations(jobMonth, jobYear, 1) // Reset to page 1 when client changes
    }
  }, [selectedClient, clientEntityId])

  // Updated pagination handler to call API with new page
  const handlePageChange = (event, value) => {
    setCurrentPage(value)
    const jobMonth = currentDate.getMonth() + 1
    const jobYear = currentDate.getFullYear()
    ApiCallGetAllocations(jobMonth, jobYear, value)
  }

  const date = new Date()
  const currentMonthYear = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, "0")}`
  const [values, setValues] = useState({
    fromDate: "",
    toDate: "",
  })

  const handleChange = (e) => {
    const { name, value } = e.target
    setValues((prev) => ({ ...prev, [name]: value }))
  }

  const handleCommentChange = (e) => {
    setAddComment(e.target.value)
  }

  const handlePrevMonth = () => {
    setCurrentDate((prevDate) => {
      const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() - 1, 1)
      const jobMonth = newDate.getMonth() + 1 // Convert to 1-based month
      const jobYear = newDate.getFullYear()

      // Call the API with the new month and year
      ApiCallGetAllocations(jobMonth, jobYear, 1) // Reset to page 1 when month changes
      dispatch(setDate(newDate))
      setCurrentPage(1)

      return newDate // Update the state with the new date
    })
  }

  const handleNextMonth = () => {
    setCurrentDate((prevDate) => {
      const newDate = new Date(prevDate.getFullYear(), prevDate.getMonth() + 1, 1)
      const jobMonth = newDate.getMonth() + 1 // Convert to 1-based month
      const jobYear = newDate.getFullYear()

      // Call the API with the new month and year
      ApiCallGetAllocations(jobMonth, jobYear, 1) // Reset to page 1 when month changes
      dispatch(setDate(newDate))
      setCurrentPage(1)

      return newDate // Update the state with the new date
    })
  }

  useEffect(() => {
    if (selectedDateRedux) {
      setCurrentDate(new Date(selectedDateRedux))
    }
  }, [selectedDateRedux])

  const handleDateChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newDate = new Date(event.target.value + "-01")
    setCurrentDate(newDate)

    // Call API with the new date
    const jobMonth = newDate.getMonth() + 1
    const jobYear = newDate.getFullYear()
    ApiCallGetAllocations(jobMonth, jobYear, 1) // Reset to page 1 when date changes
    dispatch(setDate(event.target.value))
    setCurrentPage(1)
  }

  const formatDate = (date: Date) => {
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`
  }

  const getFirstDayOfCurrentMonth = () => {
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, "0") // months are 0-indexed
    return `${year}-${month}-01`
  }

  const minDate = getFirstDayOfCurrentMonth()

  const handleSelectChangeVenue = (e) => {
    setSelectedValues(e.target.value)
  }

  useEffect(() => {
    const fetchData = async () => {
      // const currentDate = new Date()
      const jobMonth = currentDate.getMonth() + 1
      const jobYear = currentDate.getFullYear()
      await ApiCallGetAllocations(jobMonth, jobYear, 1) // Start with page 1
      await handleGetVisitTimeList()
      //await ApiCallGetVenueList()
      await handleGetClientList()
    }
    fetchData()
    return () => { }
  }, [debouncedVenue])

  // Updated ApiCallGetAllocations with proper pagination
  const ApiCallGetAllocations = async (jobMonth: number, jobYear: number, page: number = currentPage) => {
    const offset = (page - 1) * itemsPerPage
    let data = `?offset=${offset}&limit=${itemsPerPage}&jobMonth=${jobMonth}&jobYear=${jobYear}`

    if (venueNameValue) data += `&venueId=${venueNameValue}`
    if (clientEntityId) data += `&clientEntityId=${clientEntityId}`
    if (selectedClient?.clientGroupName) data += `&allocationClientGroup=${selectedClient.clientGroupName}`

    try {
      const res = await ApiGetAllocations(data)
      setAllocations(res?.data || [])

      // Set total count from API response for pagination
      if (res?.totalDataCount !== undefined) {
        setTotalCount(res.totalDataCount)
      }
    } catch (error) {
      console.error("Error fetching allocations:", error)
      toast.error("Failed to load allocations")
    }
  }

  const ApiCallGetVenueList = async (debouncedClientEntityId?: any) => {
    let data = `?offset=0&limit=500`
    if (clientEntityId) {
      data += `&clientEntityId=${clientEntityId}&clientGroupName=${selectedClient.clientGroupName}&isSelectedClient=true&venueStatus=active`
    } else if (selectedClient?.clientGroupName) {
      data += `&clientGroupName=${selectedClient.clientGroupName}&isSelectedClient=true&venueStatus=active`
    }
    const res = await ApiGetVenueList(data)
    setVenus(res?.data)
    const response = res?.data.map((item) => ({
      label: item.venueName,
      value: item.venueId,
      state: item.state,
      entityTypeName: item.entityTypeName
    }))
    setVenueName(response)
  }

  const handleGetVisitTimeList = async () => {
    try {
      const response: any = await ApiGetVisitTimes()
      setVisitTimes(response?.data)
    } catch (error) {
      console.error("Error during API call:", error)
    }
  }

  useEffect(() => {
    if (debouncedClientEntityId || selectedClient?.clientGroupName) {
      ApiCallGetVenueList(debouncedClientEntityId) // Call API only when debounced value changes
    } else {
      setVenueName([]) // Clear venue list when business is cleared
      setVenueNameValue(null) // Also clear selected venue
    }
  }, [debouncedClientEntityId, selectedClient?.clientGroupName])

  useEffect(() => {
    if (clientEntityId === null) {
      setVenueName([])
    }
  }, [clientEntityId])

  const [open, setOpen] = useState(false)

  const handleClickOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  const handleUpdate = async () => {
    if (Number(maxAge) <= Number(minAge)) {
      return
    }

    const param = {
      allocationId: allocation?.allocationId,
      userId: allocation.userId,
      allocationStatusId: allocationStatus,
      visitDaysInformation: visitDays.join(", "),
      visitTimeInformation: visitTimesValue.join(", "),
      specialComment: addComment,
      minDate: moment(values.fromDate, "YYYY-MM-DD").format("DD"),
      maxDate: moment(values.toDate, "YYYY-MM-DD").format("DD"),
      minAge: minAge,
      maxAge: maxAge,
      gender: gender,
      modifiedBy: visitTimesValue.modifiedBy,
    }
    try {
      const res = await ApiPutUpdateAllocation(param)
      const jobMonth = currentDate.getMonth() + 1
      const jobYear = currentDate.getFullYear()
      await ApiCallGetAllocations(jobMonth, jobYear, currentPage) // Keep current page after update
      setOpen(false)
      toast.success("Allocations updated successfully!")
    } catch (error) {
      console.error("Error during API call:", error)
    }
  }

  const handleAddedAllocations = async () => {
    if (venueNameValue === "") {
      toast.error("Select Value")
      return
    } else if (bulkCreateValue === "Bulk Create") {
      toast.error("Select Bulk Create")
      return
    }
    if (bulkCreateValue === "Custom") {
      if (monthly.length === 0) {
        toast.error("Select month")
        return
      }
    }

    const param = {
      year: bulkCreateValue === "Custom" ? Number(year) : Number(bulkCreateValue),
      venueId: venueNameValue,
      durationType: bulkCreateValue === "Custom" ? "custom_month" : "year",
      months: monthly,
      clientEntityId: clientEntityId,
      ... (bulkCreateValue === "Custom" && isNeedallocationCount && { isSpecialCase: true }),
      ... (bulkCreateValue === "Custom" && isNeedallocationCount && { allocationCreateCount: allocationCreateCount })
    }

    try {
      const res = await ApiPostCreateAllocations(param)
      toast.success("Allocations Added successfully!")
      setBulkCreateValue("Bulk Create")
      setMonthly([])
      setEvery("")
      const jobMonth = currentDate.getMonth() + 1
      const jobYear = currentDate.getFullYear()
      ApiCallGetAllocations(jobMonth, jobYear, 1) // Reset to page 1 after adding allocations
      setCurrentPage(1)
    } catch (error: any) {
      console.log("Error during:", error)
      toast.error(error)
    }
  }

  const handleClearData = () => {
    handleAddedAllocations()
  }

  // useEffect(() => {
  //   console.log("ClientId", ClientId)
  //   handleGetClientList()
  // }, [ClientId])

  useEffect(() => {
    if (selectedClient?.clientGroupName) {
      handleGetClientList()
    }
  }, [selectedClient?.clientGroupName])
  
  const handleGetClientList = async () => {
    const data = `?ClientGroupName=${selectedClientName?.clientGroupName}`
    if (!selectedClient?.clientGroupName) return
    try {
      const res: any = await ApiGetClientEntityByClientGroupId(data)
      setClientEntityList(res.data)
    } catch (error) {
      console.error("Error during API call:", error)
    }
  }

  const handleCancelJob = async (allocationId) => {
    const data = `?allocationId=${allocationId}`
    try {
      const response: any = await ApiPutCancelJob(data)
      toast.success("Allocation Cancelled successfully!")
      const jobMonth = currentDate.getMonth() + 1
      const jobYear = currentDate.getFullYear()
      await ApiCallGetAllocations(jobMonth, jobYear, currentPage) // Keep current page after cancellation
    } catch (error) {
      console.error("Error during API call:", error)
      toast.error(error)
    }
  }

  return (
    <Box className="p-2 w-100">
      <Box className="bg-white border-10 p-3">
        <Stack spacing={3}>
          <Box sx={{ width: "100%" }}>
            <Grid container className="d-flex align-items-center justify-content-between w-100 mb-4">
              <Grid size={{ xs: 12, md: "auto" }}>
                <Typography className="fs-42 text-center">
                  Allocations
                </Typography>
              </Grid>
              <Grid size={{ xs: 12, md: "grow" }}>
                <Box
                  flexGrow={1}
                  sx={{
                    display: "flex",
                    justifyContent: { md: "end", xs: "center" },
                    alignItems: "center",
                    // marginBottom: "70px",
                  }}
                >
                  <IconButton onClick={handlePrevMonth}>
                    <ChevronLeftIcon />
                  </IconButton>
                  <Box sx={{ display: "flex", alignItems: "center", mx: 0 }}>
                    <input
                      type="month"
                      value={formatDate(currentDate)}
                      onChange={handleDateChange}
                      className="primary-color"
                      style={{
                        // maxWidth: "160px",
                        border: "none",
                        background: "none",
                        fontSize: "1.25rem",
                        fontWeight: "bold",
                        cursor: "pointer",
                        fontFamily: "inherit",
                      }}
                    />
                  </Box>
                  <IconButton onClick={handleNextMonth}>
                    <ChevronRightIcon />
                  </IconButton>
                </Box>
              </Grid>
            </Grid>

            <Grid
              className='mb-4 mt-md-2 mt-4 d-flex justify-content-between'
              container
              gap={2}
            >
              <Grid size={{ xs: 12, md: "auto" }}>
                <Box className='d-flex' flexDirection={{ xs: "column", md: "row" }} gap={1}>
                  <Stack direction="row" spacing={1}>
                    <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                      <Autocomplete
                        disablePortal
                        id="mm-autocomplete"
                        options={Clientlist}
                        value={selectedClient}
                        getOptionLabel={(option: any) => option?.clientGroupName}
                        isOptionEqualToValue={(option: any, value: any) =>
                          option.clientGroupDBName === value.clientGroupDBName
                        }
                        onChange={(event, newValue: any) => {
                          // setSelectedClient(newValue)
                          dispatch(setSelectedClientGroup(newValue))
                          setClientId(newValue?.clientGroupName || null)
                          setClientEntityId(null)
                          setVenueNameValue(null)
                          setClientEntityList([])
                        }}
                        defaultValue="mmcommon"
                        renderInput={(params) => <TextField {...params} label="Select Client" />}
                        size="small"
                      />
                    </FormControl>
                  </Stack>
                  <Stack direction={{ xs: "column", md: "row" }} spacing={1}>
                    <FormControl size="small" sx={{ width: { xs: "100%", md: 180 } }}>
                      <Autocomplete
                        disablePortal
                        id="beacon-autocomplete"
                        options={clientEntityList?.filter((item) => item.clientEntityId !== null)} // filter out invalid entries
                        getOptionLabel={(option) => option?.entityName || ""} // properly show label
                        onChange={(event, newValue: any) => {
                          setClientEntityId(newValue?.clientEntityId || null)
                          // Clear venue when business is cleared
                          if (!newValue) {
                            setVenueNameValue(null)
                          }
                        }}
                        value={clientEntityList?.find((option) => option?.clientEntityId === clientEntityId) || null}
                        renderInput={(params) => <TextField {...params} label="Select Business" />}
                        size="small"
                      />
                    </FormControl>
                    <FormControl size="small" sx={{ width: { xs: "100%", md: 250 } }}>
                      <Autocomplete
                        disablePortal
                        id="mm-autocomplete"
                        options={venueName}
                        getOptionLabel={(option: any) => `${option?.label} (${option?.state}) (${option?.entityTypeName})`}
                        value={venueName.find((option: any) => option.value === venueNameValue) || null}
                        onChange={(event, newValue: any) => {
                          setVenueNameValue(newValue?.value)
                        }}
                        defaultValue=""
                        renderInput={(params) => <TextField {...params} label="Search Site" />}
                        size="small"
                      />
                    </FormControl>
                  </Stack>
                </Box>
              </Grid>
              <Grid size={{ xs: 12, md: "auto" }}>
                <Box className='w-100' sx={{ display: "grid", gap: "20px", marginLeft: { xs: 0, md: "auto" } }}>
                  <Box className='w-100' sx={{ marginLeft: { xs: 0, md: "auto" }, display: "flex", gap: 2, justifyContent: "center", flexWrap: 'wrap' }}>

                    <FormControl size="small" sx={{ minWidth: 150 }}>
                      <Select
                        value={bulkCreateValue}
                        displayEmpty
                        onChange={(event) => setBulkCreateValue(event.target.value)}
                      >
                        <MenuItem value="Bulk Create" disabled>
                          Bulk Create
                        </MenuItem>

                        {[
                          new Date().getFullYear() - 1, // Previous year
                          new Date().getFullYear(), // Current year
                          new Date().getFullYear() + 1, // Next year
                        ].map((year) => (
                          <MenuItem key={year} value={year.toString()}>
                            {year}
                          </MenuItem>
                        ))}

                        <MenuItem value="Custom">Custom</MenuItem>
                      </Select>
                    </FormControl>
                    {bulkCreateValue === "Custom" && (
                      <FormControl size="small" sx={{ minWidth: 150 }}>
                        <Select
                          style={{ width: "150px" }}
                          multiple
                          value={monthly}
                          displayEmpty
                          onChange={(event) => {
                            setMonthly(event.target.value as string[])
                          }}
                          renderValue={(selected) =>
                            selected.length === 0
                              ? "Monthly"
                              : selected.map((id) => monthsData.find((m) => m.id === id)?.label).join(", ")
                          }
                        >
                          {monthsData.map((items) => (
                            <MenuItem key={items.id} value={items.id}>
                              {items.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                    {bulkCreateValue === "Custom" && (
                      <FormControl size="small" sx={{ minWidth: 150 }}>
                        <Select
                          style={{ width: "150px" }}
                          // multiple
                          value={year}
                          displayEmpty
                          onChange={(event) => {
                            setYear(event.target.value)
                          }}
                          renderValue={(selected) => {
                            if (!selected) {
                              return (
                                <span style={{ color: "black" }}>
                                  Yearly
                                </span>
                              );
                            }
                            return yearData.find((y) => y.value === selected)?.label || "";
                          }}
                        >
                          {yearData.map((items) => (
                            <MenuItem key={items.id} value={items.value}>
                              {items.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}

                    {bulkCreateValue === 'Custom' && (
                      <FormControl size="small" sx={{ minWidth: 150 }}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={isNeedallocationCount}
                              onChange={(event) => {
                                setIsNeedallocationCount(event.target.checked);
                              }}
                            />
                          }
                          label="Override criteria?"
                        />
                      </FormControl>
                    )}
                    {bulkCreateValue === "Custom" && isNeedallocationCount && (
                      <Box position={'relative'} className='d-flex flex-column'>
                        <Box position={'absolute'} top={-20} left={0} fontSize={'12px'}>Number of Allocations</Box>
                        <FormControl size="small" sx={{ minWidth: 150 }}>
                          <Select
                            style={{ width: "150px" }}
                            value={allocationCreateCount}
                            displayEmpty
                            onChange={(event) => {
                              setallocationCreateCount(event.target.value);
                            }}
                            renderValue={(selected) => {
                              if (!selected) {
                                return <span style={{ color: "black" }}>Number of Allocations</span>;
                              }
                              return selected; // number from 1-10
                            }}
                          >
                            {[...Array(10)].map((_, index) => {
                              const num = index + 1;
                              return (
                                <MenuItem key={num} value={num}>
                                  {num}
                                </MenuItem>
                              );
                            })}
                          </Select>
                        </FormControl>
                      </Box>

                    )}

                    <Button onClick={handleClearData} variant="contained" className="table-row-background">
                      create
                    </Button>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>



          {/* <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 2,
            padding: "15px",
            borderRadius: "5px",
            alignItems: "start",
          }}
          className="min-border-color"
        >
          <FormControl size="small" sx={{ minWidth: 180 }}>
            <Select defaultValue="" displayEmpty value={selectedValues} onChange={handleSelectChangeVenue}>
              <MenuItem value="" disabled>
                Venue
              </MenuItem>
              {venus.map((item: any, index) => (
                <MenuItem key={item.venueId} value={item.venueId}>
                  {item.venueName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Box sx={{ display: "grid", gap: "20px", marginLeft: "auto" }}>
            <Box sx={{ marginLeft: "auto", display: "flex", gap: 2 }}>
              {bulkCreateValue === "Custom" && (
                <FormControl size="small" sx={{ minWidth: 150 }}>
                  <Select
                    style={{ width: "150px" }}
                    multiple
                    value={monthly}
                    displayEmpty
                    onChange={(event) => {
                      setMonthly(event.target.value as string[])
                    }}
                    renderValue={(selected) =>
                      selected.length === 0
                        ? "Monthly"
                        : selected.map((id) => monthsData.find((m) => m.id === id)?.label).join(", ")
                    }
                  >
                    {monthsData.map((items) => (
                      <MenuItem key={items.id} value={items.id}>
                        {items.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              )}
              <FormControl size="small" sx={{ minWidth: 150 }}>
                <Select
                  value={bulkCreateValue}
                  displayEmpty
                  onChange={(event) => setBulkCreateValue(event.target.value)}
                >
                  <MenuItem value="Bulk Create" disabled>
                    Bulk Create
                  </MenuItem>

                  {[
                    new Date().getFullYear() - 1, // Previous year
                    new Date().getFullYear(), // Current year
                    new Date().getFullYear() + 1, // Next year
                  ].map((year) => (
                    <MenuItem key={year} value={year.toString()}>
                      {year}
                    </MenuItem>
                  ))}

                  <MenuItem value="Custom">Custom</MenuItem>
                </Select>
              </FormControl>

              <Button onClick={handleClearData} variant="contained" className="table-row-background">
                create
              </Button>
            </Box>
          </Box>
        </Box> */}

          <Grid
            container
            spacing={4}
            className='align-items-stretch'
          >
            {allocations?.map((allocation: any, index) => (
              <Grid
                size={{ xs: 12, md: 6 }}
                key={index}
              >
                <Card className="min-border-color w-100" style={{ height: "100%", boxShadow: "none" }} sx={{ padding: { xs: "5px", md: "16px" } }}>
                  <CardContent>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                      <div style={{ flexGrow: 1 }}>
                        <Typography variant="h6" gutterBottom>
                          {allocation?.venueId?.venueName ?? allocation?.clientEntityId?.entityName}
                        </Typography>
                        <Typography>{allocation?.venueId?.address}</Typography>
                        <Typography>Postcode: {allocation?.venueId?.postalCode}</Typography>
                        <Typography>Visit Days: {allocation?.visitDaysInformation}</Typography>
                        <Typography>
                          Visit Times: {allocation.time}
                          {[
                            ...new Set(
                              visitTimes
                                .filter((item) =>
                                  allocation?.visitTimeInformation
                                    ?.split(",")
                                    .map((v) => v.trim())
                                    .includes(String(item.visitTimeId)),
                                )
                                .flatMap((item) => item.visitTimeInformation.split(",").map((v) => v.trim())),
                            ),
                          ].join(", ")}
                        </Typography>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          marginLeft: "16px",
                        }}
                      >
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          className="table-row-background"
                          style={{ marginBottom: "8px", width: "80px" }}
                          // disabled={allocation?.allocationStatusId?.statusDesc === "Approved"}
                          onClick={() => {
                            {
                              handleClickOpen()
                              setVisitDays(
                                allocation?.visitDaysInformation
                                  ? allocation.visitDaysInformation.split(",").map((day) => day.trim())
                                  : [],
                              )
                              const visitTimeArray = allocation?.visitTimeInformation
                                ? allocation.visitTimeInformation.split(",").map(Number)
                                : []
                              setVisitTimesValue(visitTimeArray)
                              setAllocation(allocation)
                              setAllocationStatus(allocation?.allocationStatusId?.statusId)
                              setAddComment(allocation?.specialComment || "")
                              setMinAge(allocation.minAge)
                              setMaxAge(allocation.maxAge)
                              setGender(allocation.gender)
                              setValues({
                                fromDate: `${currentMonthYear}-${String(allocation.minDate).padStart(2, "0")}`,
                                toDate: `${currentMonthYear}-${String(allocation.maxDate).padStart(2, "0")}`,
                              })
                            }
                          }}
                        >
                          Edit
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          style={{
                            marginBottom: "8px",
                            width: "80px",
                            backgroundColor: "goldenrod",
                          }}
                        >
                          {allocation?.allocationStatusId?.statusDesc}
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          className="table-row-background"
                          style={{ width: "80px" }}
                          onClick={() => {
                            const isConfirmed = window.confirm("Are you sure you want to cancel the job?")
                            if (isConfirmed) {
                              handleCancelJob(allocation?.allocationId)
                            }
                          }}
                        >
                          Revoke
                        </Button>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Stack>

        <Dialog open={open} onClose={handleClose}>
          <DialogTitle style={{ textAlign: "center" }}>Allocations UpDate</DialogTitle>
          <DialogContent>
            <div className="form-group" style={{ marginTop: "20px" }}>
              <label>Visit Days Information</label>
              <FormGroup style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
                {visitDaysOptions.map((day) => (
                  <FormControlLabel
                    key={day.value}
                    control={
                      <Checkbox
                        checked={visitDays.includes(day.value)}
                        onChange={(event) => {
                          const newVisitDays = event.target.checked
                            ? [...visitDays, day.value]
                            : visitDays.filter((val) => val !== day.value)
                          setVisitDays(newVisitDays)
                        }}
                      />
                    }
                    label={day.label}
                  />
                ))}
              </FormGroup>
            </div>

            <div className="form-group" style={{ marginTop: "20px" }}>
              <label>Visit Time Information</label>
              <FormGroup style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
                {visitTimes.map((time) => (
                  <FormControlLabel
                    key={time.visitTimeId}
                    control={
                      <Checkbox
                        checked={visitTimesValue.includes(time.visitTimeId)}
                        onChange={(event) => {
                          const newVisitTimes = event.target.checked
                            ? [...visitTimesValue, time.visitTimeId]
                            : visitTimesValue.filter((val) => val !== time.visitTimeId)
                          setVisitTimesValue(newVisitTimes)
                        }}
                      />
                    }
                    label={time.visitTimeInformation}
                  />
                ))}
              </FormGroup>
            </div>

            <div className="form-group" style={{ marginTop: "20px" }}>
              <label>Date Change Information</label>
              <FormGroup style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
                <div style={{ display: "flex", gap: "10px" }}>
                  <div style={{ flex: 1 }}>
                    <TextField
                      fullWidth
                      label="From Date"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      name="fromDate"
                      value={values.fromDate}
                      onChange={handleChange}
                      inputProps={{ min: minDate }}
                    />
                  </div>

                  <div style={{ flex: 1 }}>
                    <TextField
                      fullWidth
                      label="To Date"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      name="toDate"
                      value={values.toDate}
                      onChange={handleChange}
                      inputProps={{ min: minDate }}
                    />
                  </div>
                </div>
              </FormGroup>
            </div>

            {/* Min Age and Max Age Fields Side by Side */}
            <div className="form-group" style={{ marginTop: "20px" }}>
              <label>Age Range</label>
              <FormGroup style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
                <div style={{ display: "flex", gap: "10px", width: "100%" }}>
                  <TextField
                    fullWidth
                    label="Min Age"
                    type="number"
                    value={minAge}
                    onChange={(e: any) => {
                      const value = e.target.value
                      // Allow typing but validate after input
                      setMinAge(value)
                    }}
                    error={minAge !== "" && ((maxAge !== "" && Number(minAge) >= Number(maxAge)))}
                    helperText={
                      // minAge !== "" && Number(minAge) < 18
                      //   ? "Min Age must be at least 18"
                      //   : 
                        minAge !== "" && maxAge !== "" && Number(minAge) >= Number(maxAge)
                          ? "Min Age must be less than Max Age"
                          : ""
                    }
                  />

                  <TextField
                    fullWidth
                    label="Max Age"
                    type="number"
                    value={maxAge}
                    onChange={(e: any) => {
                      const value = e.target.value
                      // Allow typing but validate after input
                      setMaxAge(value)
                    }}
                    error={maxAge !== "" && (Number(maxAge) <= Number(minAge))}
                    helperText={
                      // minAge !== "" && Number(minAge) < 18
                      //   ? "Min Age must be at least 18"
                      //   : 
                        maxAge !== "" && Number(maxAge) <= Number(minAge)
                          ? "Max Age must be greater than Min Age"
                          : ""
                    }
                  />
                </div>
              </FormGroup>
            </div>

            {/* Gender Field */}
            <div className="form-group" style={{ marginTop: "20px" }}>
              <label>Gender</label>
              <TextField
                fullWidth
                select
                label="Gender"
                name="gender"
                value={gender}
                onChange={(e: any) => setGender(e.target.value)}
              >
                {["Male", "Female", "All"].map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </TextField>
            </div>

            {/* Add Comment Field */}
            <div className="form-group" style={{ marginTop: "20px" }}>
              <label>Add Comment</label>
              <TextField
                fullWidth
                multiline
                rows={3}
                variant="outlined"
                name="comment"
                value={addComment}
                onChange={handleCommentChange}
                placeholder="Enter your comment here..."
              />
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <Button
                variant="contained"
                color="primary"
                size="small"
                className="table-row-background"
                style={{ width: "200px", padding: "10px" }}
                onClick={handleUpdate}
              >
                Allocation Update
              </Button>
              <Button
                onClick={handleClose}
                variant="contained"
                color="primary"
                size="small"
                className="table-row-background"
                style={{ width: "200px", padding: "10px" }}
              >
                Close
              </Button>
            </div>
          </DialogContent>
        </Dialog>

        {/* Updated Pagination - now uses totalCount from API */}
        {totalCount > itemsPerPage && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              // alignItems: "center",
              margin: "20px 0px",
            }}
          >
            <Pagination
              count={Math.ceil(totalCount / itemsPerPage)}
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
            />
          </Box>
        )}
      </Box>
    </Box>
  )
}
